const queryKeys = {
  listing: {
    full: ['listing-full'] as const,
  },
  rankingAnalytics: {
    full: ['rankingAnalytics-full'] as const,
  },
  localGridReport: {
    full: ['localGridReport-full'] as const,
  },
  listingAnalytics: {
    full: ['listingAnalytics-full'] as const,
  },
  social: {
    analytics: ['social-analytics'] as const,
  },
  socialPosting: {
    findPosts: ['findPosts'] as const,
    findOneDraft: ['findOneDraft'] as const,
    generateContent: ['generateContent'] as const,
  },
  socialReviews: {
    inbox: ['socialReviews-inbox'] as const,
  },
  locations: {
    find: ['getLocations'] as const,
    findOne: ['findOneLocation'] as const,
  },
  reviews: {
    full: ['reviews-full'] as const,
    findAll: ['findAllReviewCampaign'] as const,
    analytics: ['reviewCampaignAnalytics'] as const,
    growthOpportunities: ['growthOpportunities'] as const,
    topics: ['reviewsTopics'] as const,
    sentiment: {
      distribution: ['sentimentDistribution'] as const,
      overTime: ['sentimentOverTime'] as const,
      ratingDistribution: ['ratingDistribution'] as const,
    },
  },
  reputation: {
    reviewsSources: ['reviewsSources'] as const,
  },
  pixabay: {
    image: ['pixabay-image'] as const,
    video: ['pixabay-video'] as const,
  },
  jooiceAi: {
    remainingAiCredits: ['remainingAiCredits'] as const,
    /**
     * Scoped by the Outseta person uid on purpose. A conversation belongs to a member, and the
     * backend answers 404 for anyone else's. Switching account in the same tab (impersonation does
     * exactly that) leaves the previous member's list in an unscoped cache, and the app then asks
     * for a conversation that is not its own — which is what "Failed to load chat" was.
     */
    findChats: (memberUid: string | undefined) => ['findChats', memberUid] as const,
    /** Prefix of `findChats` — invalidates the list for every member scope. */
    findChatsRoot: ['findChats'] as const,
  },
};

export default queryKeys;
